import type { User } from '../types/api.types';

export const getDashboardRouteForUser = (user: User | null): string => {
  if (!user) {
    return '/dashboard';
  }

  const userRole = user.Staff?.role || user.profile?.role || user.staffRole;
  
  if (userRole === 'super_admin') {
    return '/dashboard/system';
  }
  
  return '/dashboard';
};

export const isSuperAdminUser = (user: User | null): boolean => {
  if (!user) return false;
  
  const userRole = user.Staff?.role || user.profile?.role || user.staffRole;
  return userRole === 'super_admin';
};